import { Component, AfterViewInit, ViewChild, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ProjetosService } from '../projetos.service';
import { UtilsService } from '../utils.service';
import { LoginService } from '../login.service';
import { TemplateService } from '../template.service';

@Component({
  selector: 'app-cadastro-projeto',
  templateUrl: './cadastro-projeto.component.html',
  styleUrls: ['./cadastro-projeto.component.css']
})
export class CadastroProjetoComponent implements OnInit {
  progressBar:boolean = false;
  public projeto:any = {
                  id:null,
                  descricao: "",
                  tipoProjeto: "",
                  idTemplateProjeto: "",
                  dataInicio: "",
                  dataPrevistaTermino:"",
                  idUsuario: 0
                };
  descricao_projeto:string;
  membros:any = [];
  submitted = false;
  public modelosBase:Object = [];
  public tipoProjeto:Object = [];
  public cadastroEnvolvidos:boolean = false;
  public papelMembro: Object = {};

  _novoEnvolvido: boolean = false;

  seqMembro:number = 0;
  public membro:any = {
    id: 0,
    emailMembro: '',
    perfilMembro: ''
  }

  constructor(private projetoServ:ProjetosService,
              private login: LoginService,
              private tempServ:TemplateService,
              private route: ActivatedRoute,
              private router:Router) {

    }

  ngAfterViewInit() {
    this.projeto = {
                    id:null,
                    descricao: "",
                    tipoProjeto: "",
                    idTemplateProjeto: "",
                    dataInicio: "",
                    dataPrevistaTermino:"",
                    idUsuario: 0,
                    membros: []
                  };
                  //console.log(this.projeto.id);
    /*
    let obj = UtilsService.enums.find((obj) => obj.tipo == "TIPO_PROJETO");

    if (obj["valores"] !== undefined)
      for (let idx = 0; idx < obj["valores"].length; idx++) {
        Object.defineProperty(this.tipoProjeto, obj["valores"][idx]["valor"], obj["valores"][idx]["descricao"]);
      }
    */

    
  }

  iniciliz() {
    setTimeout(function() {
      UtilsService.setDate();
      UtilsService.setSelect();

      var className = document.querySelector('#tamWidth').className.replace('s12', '');
      document.querySelector('#tamWidth').className = className + ' ' + (screen.availWidth <= 992 ? 's12' : 's6');

      //eval('document.getElementsByClassName("dropdown-content").style = "height: 250px !important"')
    }, 500);
  }

  ngOnInit() {
    this.progressBar = true;

    this.tipoProjeto = UtilsService.getEnums("TIPO_PROJETO");
    this.papelMembro = UtilsService.getEnums("PERFIL_MEMBRO_PROJETO");

    this.projeto.id = (this.route.snapshot.paramMap.get('id') !== "" ? this.route.snapshot.paramMap.get('id') : null);
    if (this.projeto.id !== null && this.projeto.id !== undefined) {
      
      this.projetoServ.getProjeto(this.projeto.id).subscribe((resp) => {
        //this.router.navigate(['/cadastro-projeto', resp["id"]])
        
        /*
        if (resp["userAdmin"] == false) {
          UtilsService.alerta('Você não é o orientador para editar esse projeto!', 'erro');
          this.router.navigate(['/projetos']);
        }
        */

        this.cadastroEnvolvidos = true;
        this.projeto = resp;
        
        //console.log(resp);

        if (this.projeto["membros"] == undefined) 
          this.projeto["membros"] = [];

        this.membros = this.projeto["membros"];

        this.cadastroEnvolvidos = true;
        this.projeto.tipoProjeto = this.projeto.tipoProjeto.toUpperCase();
        this.descricao_projeto = resp["descricao"];
        
        //this.progressBar = false;
        //this.iniciliz();

        this.selTipoProjeto();
      })
    } else {
      setTimeout(function() {
        UtilsService.setDate();
        UtilsService.setSelect();
        //eval('document.getElementsByClassName("dropdown-content").style = "height: 250px !important"')
      }, 100);
      this.progressBar = false;
    }    
    /*
    if (this.projeto.id !== null) {
      this.projeto = this.projetoServ.getProjeto();
      console.log(this.projeto);
      this.projeto.membros = [];
      this.projeto.tipoProjeto = this.projeto.tipoProjeto.toUpperCase();
      console.log(this.projeto);
    }
    */
  /*
    setTimeout(function() {
      UtilsService.setDate();
      UtilsService.setSelect();
      eval('document.getElementsByClassName("dropdown-content").style = "height: 250px !important"')
    }, 100);
  */
  }

  selTipoProjeto() {
    if (this.projeto.tipoProjeto == '') {
      this.modelosBase = [];
      this.iniciliz();
      return;
    }
    this.progressBar = true;
    this.tempServ.getTemplateByUsuarioTipoProjeto(this.projeto.tipoProjeto).subscribe((resp) => {
      this.progressBar = false;
      this.modelosBase = resp;
      //console.log(this.modelosBase);
      this.iniciliz();
    }, (resp) => {
      this.progressBar = false;
      this.iniciliz();
      UtilsService.alerta(resp.error.message, 'erro');
    });
  }

  novoProjeto() {
    this.router.navigate(['/cadastro-projeto']);
  }

  cadastrarProjeto() {
    this.submitted = true;

    var form = {};
    form["id"] = this.projeto.id;
    form["descricao"] = eval("document.getElementById('descricao').value");
    form["idTemplateProjeto"] = parseInt(eval("document.getElementById('idTemplateProjeto').value"));
    form["tipoProjeto"] = eval("document.getElementById('tipoProjeto').value");
    form["dataInicio"] = eval("document.getElementById('dataInicio').value");
    form["dataPrevistaTermino"] = eval("document.getElementById('dataPrevistaTermino').value");
    form["idUsuario"] = this.login.getUsuario("id");

    //console.log(this.projeto.idTemplateProjeto, form["idTemplateProjeto"], this.projeto.id);
    if (this.projeto.idTemplateProjeto !== form["idTemplateProjeto"] && this.projeto.id !== null) {
      UtilsService.confirmacao('Atenção', 'Deseja remover as atividades e tarefas criadas automaticamente pelo outro modelo selecionado?').then((resp) => {
        if (resp.value == true) {
          form["limparModelo"] = true;
        } 
        
        this.salvarProjeto(form);
      })
    } else this.salvarProjeto(form);
    //console.log(form);
  }

  salvarProjeto(form) {
    /*
    for (let item in this.projeto.membros) {
      console.log(this.projeto.membros[item]["id"]);
      if (this.projeto.membros[item]["id"] !== undefined) {
        if (this.projeto.membros[item]["id"][0] == "_")
          form["membros"].push({ emailMembro: this.projeto.membros[item]["emailMembro"], perfilMembro: this.projeto.membros[item]["perfilMembro"] });
        else form["membros"].push(this.projeto.membros[item]);
      } else form["membros"].push(this.projeto.membros[item]);
    }
    */

    this.progressBar = true;
    this.projetoServ.cadastrarProjeto(form).subscribe(resp => {
        this.progressBar = false;

        try {
          if (this.projeto.id == null) {
            UtilsService.alerta("Projeto cadastrado com sucesso.");
            //this.projeto.id = resp["id"];
            this.router.navigate(["cadastro-projeto", resp["id"], resp["descricao"]]);
          } else {
            UtilsService.alerta("Projeto atualizado com sucesso.");
            this.router.navigate(["cadastro-projeto", resp["id"], resp["descricao"]]);
            this.cadastroEnvolvidos = true;

            this.iniciliz();
          }
        } catch (error) {
          
        }
      }, resp => {
        //console.log("Error", resp.error.message);
        this.progressBar = false;
        UtilsService.alerta(resp.error.message, 'erro');
        this.iniciliz();
        //eval("M.toast({html: '" + resp.error.message + "'})");
      });
  }

  novoEnvolvido() {
    this.membro.id = 0;
    this._novoEnvolvido = false;
    this.membro.emailMembro = '';
    this.membro.perfilMembro = '';

    this._novoEnvolvido = true;
    setTimeout(function() {
      UtilsService.setSelect();
    }, 500);
  }

  removerMembro(item:Object) {
      if (item["emailMembro"] == this.login.getUsuario("email")) {
        UtilsService.alerta('Você não pode se desvincular do projeto porque é o orientador!', 'erro');
        return;
      } else this.projetoServ.removerMembroProjeto(this.projeto.id, item["id"]).subscribe((resp) => {
        this.ngOnInit();
      }, resp => {
        this.progressBar = false;
        UtilsService.alerta(resp.error.message, 'erro');
        setTimeout(function() {
          UtilsService.setSelect();
        }, 500);
      });
  }

  cancelarEnvolvido() {
    this._novoEnvolvido = false;
  }

  salvarEnvolvido() {
    if (this.membro.emailMembro == undefined || this.membro.emailMembro == '') {
      UtilsService.alerta("O nome do envolvido é obrigatório!", "erro"); 
      return;
    } else if (this.membro.perfilMembro == '' || this.membro.perfilMembro == undefined) {
      UtilsService.alerta("Papel do membro é obrigatório!", "erro"); 
      return;
    }
    let edicao = false;

    this.progressBar = true;
    this.projetoServ.cadastrarMembro(this.projeto.id, {
      emailMembro: this.membro.emailMembro,
      perfilMembro: this.membro.perfilMembro
    }).subscribe((resp) => {
        this.progressBar = false;
        this.membros.push(resp);

        if (edicao == false) {
          this.membro.id = "_" + this.seqMembro + 1;
          this.seqMembro += 1;
        }

        this._novoEnvolvido = false;
        setTimeout(function() {
          UtilsService.setSelect();
        }, 500);
    }, resp => {
      this.progressBar = false;
      UtilsService.alerta(resp.error.message, 'erro');
      setTimeout(function() {
        UtilsService.setSelect();
      }, 500);
    })
  }

  editarTemplate() {
    if (this.projeto.tipoProjeto !== '')
      this.router.navigate(['/template/', this.projeto.tipoProjeto]);
  }
}